var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"test-class"},[_c('mc-summary',{attrs:{"data-testid":"summary-page","model":_vm.model,"fluent":_vm.fluent},on:{"update:model":function($event){_vm.model=$event},"update:fluent":function($event){_vm.fluent=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }